function getSiblings(element) {
  const parent = element.parentNode;
  const childNodesArray = Array.from(parent.children);
  const siblings = childNodesArray.filter(function(sibling) {
    return sibling !== element;
  });
  return siblings;
}
function closeAllSiblings(accordionElement) {
  const siblings = getSiblings(accordionElement);
  siblings.forEach(function(sibling) {
    sibling.removeAttribute("open");
  });
}
function toggleAccordionElements() {
  document.querySelectorAll(".accordion").forEach(function(accordionElement) {
    accordionElement.addEventListener("click", function() {
      if (!accordionElement.hasAttribute("open")) {
        closeAllSiblings(accordionElement);
      }
    });
  });
}
function initAccordion() {
  if (!!document.location.hash) {
    const anchorElement = document.querySelector(document.location.hash);
    if (!!anchorElement && anchorElement.closest(".accordion")) {
      const accordionElement = anchorElement.closest(".accordion");
      const headerHeight = document.querySelector(".header").offsetHeight;
      accordionElement.setAttribute("open", "open");
      closeAllSiblings(accordionElement);
      window.scrollTo(0, accordionElement.offsetTop - headerHeight);
    }
  }
}
initAccordion();
toggleAccordionElements();
